import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getLocalStorageValue } from "config/helper";

export function useApiDefaults(options = {}) {
  const storeCurrentStoreID = useSelector(({ store }) => store?.currentStoreID);
  const storeIsUserLoggedIn = useSelector(({ user }) => user?.isUserLoggedIn);
  
  const RSAClientId = useMemo(() => options?.RSAClientId || getLocalStorageValue("RSAclient-id"), [options?.RSAClientId]);
  const ClientStoreId = +(options?.ClientStoreId || storeCurrentStoreID || getLocalStorageValue("selected-store-id")) || 1
  const isUserLoggedIn = options?.isUserLoggedIn ?? storeIsUserLoggedIn;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const member_number = useMemo(() => options?.member_number || getLocalStorageValue("member-number"), [isUserLoggedIn, options?.member_number]);
  const user_token = useMemo(() => options?.user_token || getLocalStorageValue("user-token"), [options?.user_token]);   

  return {
    RSAClientId,
    ClientStoreId,
    AppName: isUserLoggedIn ? (options?.AppName || "shop") : "",
    member_number: isUserLoggedIn ? member_number : "",
    user_token: isUserLoggedIn ? user_token : "",
    Version: isUserLoggedIn ? (options?.Version || "1") : "",
    DeviceType: isUserLoggedIn ? (options?.DeviceType || "web") : "",
    PageNo: options?.PageNo || 1,
  }
}